/** Clases Tailwind estándar — sistema empresarial */

export const inputCls =
  'w-full bg-surface-overlay border border-line rounded px-3 py-2 text-sm text-ink placeholder-ink-faint ' +
  'focus:outline-none focus-ring transition-colors';

export const selectCls =
  'w-full bg-surface-overlay border border-line rounded px-3 py-2 text-sm text-ink ' +
  'focus:outline-none focus-ring transition-colors';

export const labelCls =
  'block text-[11px] font-semibold text-ink-faint mb-1 uppercase tracking-wider';

export const btnPrimary =
  'btn-primary px-4 py-2 rounded text-xs font-semibold ' +
  'tracking-wide transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

export const btnSecondary =
  'border border-line text-ink-muted hover:text-ink hover:border-line/80 hover:bg-surface-overlay ' +
  'px-4 py-2 rounded text-xs font-medium transition-colors';

export const btnDanger =
  'border border-red-900 bg-red-950/60 hover:bg-red-900/50 text-red-400 hover:text-red-300 ' +
  'px-4 py-2 rounded text-xs font-semibold transition-colors disabled:opacity-40';

export const cardCls =
  'bg-surface-raised border border-line rounded-lg';

export const tableWrapCls =
  'overflow-x-auto border border-line rounded-lg';

export const theadCls =
  'bg-surface-overlay text-ink-faint border-b border-line';

export const thCls =
  'text-left px-3 py-2.5 text-[11px] font-semibold uppercase tracking-wider whitespace-nowrap';

export const trCls =
  'border-b border-line-dim hover:bg-surface-overlay/60 transition-colors';

export const tdCls =
  'px-3 py-2.5 text-xs text-ink-muted';

export const errorCls = 'text-red-400 text-xs mt-1';

export const pageTitleCls   = 'text-lg font-semibold text-ink tracking-tight';
export const pageSubtitleCls = 'text-ink-faint text-xs mt-0.5';

/** Sección dentro de un form — línea divisora + label */
export const sectionLabelCls =
  'text-[10px] font-bold text-ink-faint uppercase tracking-widest pb-1.5 border-b border-line mb-3';
